module.exports = __webpack_public_path__ + "static/icon7-b1fe17981114e3920870e8c72a864876.png";